import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { PlaceOfDeathInput } from '../../../BasePersonInputs/PlaceOfDeath/PlaceOfDeathInput';

export function PlaceOfDeathField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={PlaceOfDeathInput}
      label='Vorname'
    />
  );
}
